import { Link } from 'react-router-dom';
import { animeList, hotAnimeIds } from '@/mocks/anime';
import AnimeCard from '@/components/base/AnimeCard';

export default function HotRecommend() {
  const hotAnimes = hotAnimeIds.map((id) => animeList.find((a) => a.id === id)!).filter(Boolean);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的动漫精选</p>
          </div>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            更多推荐 <i className="ri-arrow-right-line align-middle"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotAnimes.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} size="medium" />
          ))}
        </div>
      </div>
    </section>
  );
}